<template>
  <div class="stock-macd-view">
    <StockMACD />
  </div>
</template>

<script>
import StockMACD from '@/components/indicators/StockMACD.vue'

export default {
  name: 'StockMACDView',
  components: {
    StockMACD
  }
}
</script>

<style scoped>
.stock-macd-view {
  padding: 20px;
  flex: 1;
}
</style>
